export let selectTabs = [
  {
    label: '全部列表',
    value: 'ALL'
  },
  {
    label: '待审核列表',
    value: 'WAITING_FOR_AUDIT'
  },
  {
    label: '待发放列表',
    value: 'WAITING_FOR_COMPLETE'
  },
  {
    label: '已完成列表',
    value: 'FLASH_COMPLETE'
  }
]
export let filterLabels = [
  {
    label: '所在地',
    type: 'select',
    value: 'city',
    clearable: true,
    options: []
  },
  {
    label: '申请时间',
    type: 'time-slot',
    value: 'applyTime',
    clearable: true,
    startName: 'applyDateStart', // 返回数据时，开始时间的字段名
    endName: 'applyDateEnd' // 返回数据时，结束时间的字段名
  }
]
export let tableLabels = [
  {
    label: '客户姓名',
    value: 'cpsCustomerName'
  },
  {
    label: '合同编号',
    value: 'contractNumber'
  },
  {
    label: '生命银行用户',
    value: 'username'
  },
  {
    label: 'C端手机号',
    value: 'mobile'
  },
  {
    label: '所在地',
    value: 'city'
  },
  {
    label: '所属区域',
    value: 'address'
  },
  {
    label: '收款方账户名称',
    value: 'bankAccountName'
  },
  {
    label: '银行预留手机号',
    value: 'bankMobile'
  },
  {
    label: '收款账户',
    value: 'bankCardNumber'
  },
  {
    label: '申请时间',
    value: 'apply_date'
  },
  {
    label: '返现金额（元）',
    value: 'cash_back_amount'
  },
  {
    label: '款项属性',
    value: 'properties'
  },
  {
    label: '状态',
    value: 'borrowStatus'
  }
]
